import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { TYPE } from '../../../../constant';
import { diagnosisResultAPI } from '../../../../api/diagnosisAPI';
import { useHackle, useLearningHistory, useRequest, useUserInfo } from '../../../../hooks';
import useAmplitude from '../../../../hooks/useAmplitude';
import { mathpidLogAPICall } from '../../../../redux/logData';
import ResultInfo from '../aiDiagnosisTest/common/ResultInfo';

function LearningNoteTestResult() {
  const { info } = useUserInfo();
  const logDispatch = useDispatch();
  const { setAmplitudeLog } = useAmplitude();
  const { setLearningHistoryInfo } = useLearningHistory();
  const [diagnosisResultAPICall, result] = useRequest((data) =>
    diagnosisResultAPI(data)
  );
  const { setHackleInfo, clearHackleInfo } = useHackle();

  useEffect(() => {
    if (!info?.learnerId) return;
    const { learnerId, locale } = info;

    diagnosisResultAPICall({
      lrnMbrId: learnerId,
      langCd: locale
    })
    setLearningHistoryInfo({
      isCompleteAIDiagnosis: 'Y',
      isCheckAIDiagnosisResult: 'Y'
    })

    setAmplitudeLog({ 
      eventName: {
        name: '진단결과 조회',
        event: {
          "소스화면": '/courseLearning/learningNote'
        }
      }
    });

    if (info.channelCode === TYPE.CHANNEL.GLOBAL01) {
      setHackleInfo( { viewPath : 'LEARNING_RESULT', isShowHackle : true } ); // hackle 적용
    }

    return () => {
      if (info.channelCode === TYPE.CHANNEL.GLOBAL01) {
        clearHackleInfo( { viewPath : 'LEARNING_RESULT' } );
      }
    }
  }, []);

  useEffect(() => {
    if (!result) return;
    logDispatch(mathpidLogAPICall({
      verbId: 'opened',
      objectId: 'learningReport',
      idName: 'estLastStgCd',
      idValue: result.estLastStgCd,
    }));
  }, [result])

  if (!result) return <div></div>;
  return (
    <div className="layout-lr-dark">
      <ResultInfo result={result} type="note"/>
    </div>
  );
}

export default LearningNoteTestResult;